import { render, staticRenderFns } from "./PEC_paratitle.vue?vue&type=template&id=0d0bd13f"
import script from "./PEC_paratitle.vue?vue&type=script&lang=js"
export * from "./PEC_paratitle.vue?vue&type=script&lang=js"
import style0 from "./PEC_paratitle.vue?vue&type=style&index=0&id=0d0bd13f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports